import { FormCustomerAdminLayout, MenuLayout } from "../layouts";
//TODO: Send data here for Menu Layout
export const CreateCustomerPage = () => {
  return (
    <>
      <MenuLayout>
        <FormCustomerAdminLayout
          isEditMode={false}
          titlePage="Creación de Nuevo Cliente."
        />
      </MenuLayout>
    </>
  );
};
